import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getRegistration } from '../thunks/vehicleThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearVehicleKey } from '../thunkKeys/commonThunksKeys';

const SLICE_NAME = 'registration';

export const registrationSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearRegistration(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getRegistration });
        builder.addCase(
            clearVehicleKey,
            () => commonInitialState,
        );
    },
});

export const { clearRegistration } = registrationSlice.actions;

export const registration = registrationSlice.reducer;
